const OPEN_MODAL = 'scratch-gui/modals/OPEN_MODAL';
const CLOSE_MODAL = 'scratch-gui/modals/CLOSE_MODAL';

const MODAL_COSTUME_LIBRARY = 'costumeLibrary';
const MODAL_LOADING_PROJECT = 'loadingProject';
const MODAL_EXAMPLE_LIBRARY = 'exampleLibrary';

const initialState = {
    [MODAL_COSTUME_LIBRARY]: false,
    [MODAL_LOADING_PROJECT]: false,
    [MODAL_EXAMPLE_LIBRARY]: false
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case OPEN_MODAL:
        return Object.assign({}, state, {
            [action.modal]: true
        });
    case CLOSE_MODAL:
        return Object.assign({}, state, {
            [action.modal]: false
        });
    default:
        return state;
    }
};
const openModal = function (modal) {
    return {
        type: OPEN_MODAL,
        modal: modal
    };
};
const closeModal = function (modal) {
    return {
        type: CLOSE_MODAL,
        modal: modal
    };
};
const openCostumeLibrary = function () {
    return openModal(MODAL_COSTUME_LIBRARY);
};
const openLoadingProject = function () {
    return openModal(MODAL_LOADING_PROJECT);
};
const openExampleLibrary = function () {
    return openModal(MODAL_EXAMPLE_LIBRARY);
};
const closeCostumeLibrary = function () {
    return closeModal(MODAL_COSTUME_LIBRARY);
};
const closeLoadingProject = function () {
    return closeModal(MODAL_LOADING_PROJECT);
};
const closeExampleLibrary = function () {
    return closeModal(MODAL_EXAMPLE_LIBRARY);
};
export {
    reducer as default,
    initialState as modalsInitialState,
    openCostumeLibrary,
    openLoadingProject,
    openExampleLibrary,
    closeCostumeLibrary,
    closeLoadingProject,
    closeExampleLibrary
};
